import { createContext } from 'react';

const TownCaseChatContext = createContext(null);

export default TownCaseChatContext;
